import { render, staticRenderFns } from "./CapturePresentingQuestionAnswersModal.vue?vue&type=template&id=6622c218&"
import script from "./CapturePresentingQuestionAnswersModal.vue?vue&type=script&lang=js&"
export * from "./CapturePresentingQuestionAnswersModal.vue?vue&type=script&lang=js&"
import style0 from "./CapturePresentingQuestionAnswersModal.vue?vue&type=style&index=0&id=6622c218&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports